import { logger } from '@packages/shared';
import type { GtmGenericEvent } from './types.events';

const dispatchGTMEvent = <T extends GtmGenericEvent>(
  event: T,
  dataLayerName = 'dataLayer',
): void => {
  if (typeof window !== 'undefined' && (window as any)[dataLayerName]) {
    (window as any)[dataLayerName].push(event);
  } else {
    logger.warn('[GTM] No datalayer!');
  }
};

export { dispatchGTMEvent };
